import { NgModule } from '@angular/core';
import { ApolloQueryService } from 'app/shared/apollo';

@NgModule({
  providers: [ApolloQueryService],
})
export class ApolloMasterModule {}
